import { render } from "./EditarConstrucao.vue?vue&type=template&id=aaee66f4"
import script from "./EditarConstrucao.vue?vue&type=script&lang=js"
export * from "./EditarConstrucao.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__